export const ROLES_DEFAULT = {
  ID: '01FMS2V8BXPV30W7MSFHWRDSTY',
  ROLE_NAME: '管理者',
};
